import { useTranslation } from 'react-i18next'

import * as Icon from '@makyoapp/makyo-icon/icon'

import Notice from './Notice'

/**
 * Check2FaNotice is a function component that displays a notice message
 * instructing the user to enter a 6-digit code from their authenticator app.
 * It uses the useTranslation hook to support localization.
 *
 * @returns {JSX.Element} A div element containing the notice message.
 */
function Check2FaNotice() {
  // Hook to handle localization
  const { t } = useTranslation()

  // Return JSX to render
  return (
    <div className='mb-4'>
      <Notice icon={<Icon.Lock24 className='fill-zinc-500' />}>
        {t('Please enter the 6-digit code from your authenticator app')}
      </Notice>
    </div>
  )
}

export default Check2FaNotice
